/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ExecuteNotificationProcessBody,
  ExecuteNotificationProcessParams,
  ExecuteQueryBody,
  FilterOptionDTO,
  QueryServiceInfo
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const executeNotificationProcess = (
    serviceName: string,
    executeNotificationProcessBody: ExecuteNotificationProcessBody,
    params: ExecuteNotificationProcessParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/v1/notification-processes/${serviceName}/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeNotificationProcessBody,
        params, signal
    },
      options);
    }
  


export const getExecuteNotificationProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeNotificationProcess>>, TError,{serviceName: string;data: ExecuteNotificationProcessBody;params: ExecuteNotificationProcessParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeNotificationProcess>>, TError,{serviceName: string;data: ExecuteNotificationProcessBody;params: ExecuteNotificationProcessParams}, TContext> => {

const mutationKey = ['executeNotificationProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeNotificationProcess>>, {serviceName: string;data: ExecuteNotificationProcessBody;params: ExecuteNotificationProcessParams}> = (props) => {
          const {serviceName,data,params} = props ?? {};

          return  executeNotificationProcess(serviceName,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteNotificationProcessMutationResult = NonNullable<Awaited<ReturnType<typeof executeNotificationProcess>>>
    export type ExecuteNotificationProcessMutationBody = ExecuteNotificationProcessBody
    export type ExecuteNotificationProcessMutationError = unknown

    export const useExecuteNotificationProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeNotificationProcess>>, TError,{serviceName: string;data: ExecuteNotificationProcessBody;params: ExecuteNotificationProcessParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeNotificationProcess>>,
        TError,
        {serviceName: string;data: ExecuteNotificationProcessBody;params: ExecuteNotificationProcessParams},
        TContext
      > => {

      const mutationOptions = getExecuteNotificationProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const executeQuery = (
    serviceName: string,
    executeQueryBody: ExecuteQueryBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/v1/notification-processes/${serviceName}/execute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeQueryBody, signal
    },
      options);
    }
  


export const getExecuteQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{serviceName: string;data: ExecuteQueryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{serviceName: string;data: ExecuteQueryBody}, TContext> => {

const mutationKey = ['executeQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeQuery>>, {serviceName: string;data: ExecuteQueryBody}> = (props) => {
          const {serviceName,data} = props ?? {};

          return  executeQuery(serviceName,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteQueryMutationResult = NonNullable<Awaited<ReturnType<typeof executeQuery>>>
    export type ExecuteQueryMutationBody = ExecuteQueryBody
    export type ExecuteQueryMutationError = unknown

    export const useExecuteQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{serviceName: string;data: ExecuteQueryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeQuery>>,
        TError,
        {serviceName: string;data: ExecuteQueryBody},
        TContext
      > => {

      const mutationOptions = getExecuteQueryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllQueryServices = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QueryServiceInfo[]>(
      {url: `/api/v1/notification-processes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllQueryServicesQueryKey = () => {
    return [`/api/v1/notification-processes`] as const;
    }

    
export const getGetAllQueryServicesQueryOptions = <TData = Awaited<ReturnType<typeof getAllQueryServices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllQueryServicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllQueryServices>>> = ({ signal }) => getAllQueryServices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllQueryServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllQueryServices>>>
export type GetAllQueryServicesQueryError = unknown


export function useGetAllQueryServices<TData = Awaited<ReturnType<typeof getAllQueryServices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllQueryServices>>,
          TError,
          Awaited<ReturnType<typeof getAllQueryServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllQueryServices<TData = Awaited<ReturnType<typeof getAllQueryServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllQueryServices>>,
          TError,
          Awaited<ReturnType<typeof getAllQueryServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllQueryServices<TData = Awaited<ReturnType<typeof getAllQueryServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllQueryServices<TData = Awaited<ReturnType<typeof getAllQueryServices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllQueryServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllQueryServicesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFilterOptions = (
    serviceName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FilterOptionDTO[]>(
      {url: `/api/v1/notification-processes/${serviceName}/filters`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFilterOptionsQueryKey = (serviceName?: string,) => {
    return [`/api/v1/notification-processes/${serviceName}/filters`] as const;
    }

    
export const getGetFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getFilterOptions>>, TError = unknown>(serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilterOptionsQueryKey(serviceName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterOptions>>> = ({ signal }) => getFilterOptions(serviceName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterOptions>>>
export type GetFilterOptionsQueryError = unknown


export function useGetFilterOptions<TData = Awaited<ReturnType<typeof getFilterOptions>>, TError = unknown>(
 serviceName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilterOptions<TData = Awaited<ReturnType<typeof getFilterOptions>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getFilterOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilterOptions<TData = Awaited<ReturnType<typeof getFilterOptions>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFilterOptions<TData = Awaited<ReturnType<typeof getFilterOptions>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterOptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFilterOptionsQueryOptions(serviceName,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



